// extracted by mini-css-extract-plugin
export var storyRowWrapperCenter = "y_st d_bD";
export var storyRowWrapper = "y_hx d_hx d_bK";
export var storyLeftWrapper = "y_sv d_bz d_bP";
export var storyWrapperFull = "y_sw d_cD";
export var storyWrapperFullLeft = "y_pl d_cD d_bz d_bP d_bD";
export var contentWrapper = "y_mS d_hy";
export var storyLeftWrapperCenter = "y_sx d_hz d_bz d_bD d_bP d_bJ";
export var storyRightWrapperCenter = "y_sy d_hF";
export var storyHeader = "y_sz d_hD d_w d_cs";
export var storyHeaderCenter = "y_hC d_hC d_w d_cs d_dw d_by";
export var storyParagraphCenter = "y_hB d_hB d_by d_dw";
export var storyBtnWrapper = "y_sB d_d2 d_d1 d_w d_bz d_bG";
export var storyBtnWrapperCenter = "y_hJ d_hJ d_d1 d_w d_bz d_bD";
export var imageWrapper = "y_sk d_fg d_Z";
export var imageWrapperFull = "y_sC d_w d_H d_bf d_Z";
export var SubtitleSmall = "y_q3 C_q3 C_sJ C_sV";
export var SubtitleNormal = "y_q4 C_q4 C_sJ C_sW";
export var SubtitleLarge = "y_q5 C_q5 C_sJ C_sX";
export var textLeft = "y_dv";
export var textCenter = "y_dw";
export var textRight = "y_dx";